import { ExternalLink, Users, Radio, FileBarChart, HeartPulse, Shield } from "lucide-react";

const quickLinks = [
  {
    icon: Users,
    title: "Consumer 360",
    description: "Analyze consumer behavior with integrated insights",
    color: "text-primary",
    bg: "bg-primary/10",
  },
  {
    icon: Radio,
    title: "Meter 360",
    description: "Real-time monitoring and automated data collection",
    color: "text-accent",
    bg: "bg-accent/10",
  },
  {
    icon: FileBarChart,
    title: "Consumption Report",
    description: "Track usage trends and optimize efficiency",
    color: "text-chart-3",
    bg: "bg-warning/10",
  },
  {
    icon: HeartPulse,
    title: "Meter Health",
    description: "Monitor meter conditions and maintenance needs",
    color: "text-success",
    bg: "bg-success/10",
  },
  {
    icon: Shield,
    title: "Revenue Protection",
    description: "Detect anomalies and prevent revenue loss",
    color: "text-destructive",
    bg: "bg-destructive/10",
  },
];

const QuickAccess = () => {
  return (
    <div className="bg-card rounded-xl border border-border p-5">
      <h3 className="font-heading font-semibold text-foreground mb-4">
        Quick Access
      </h3>
      
      <div className="space-y-3">
        {quickLinks.map((link, index) => (
          <button
            key={index}
            className="w-full flex items-start gap-3 p-3 rounded-lg hover:bg-secondary/50 transition-colors text-left group"
          >
            <div className={`p-2 rounded-lg ${link.bg}`}>
              <link.icon className={`w-4 h-4 ${link.color}`} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-1.5">
                <span className="font-medium text-sm text-foreground">
                  {link.title}
                </span>
                <ExternalLink className="w-3 h-3 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
              <p className="text-xs text-muted-foreground mt-0.5 line-clamp-2">
                {link.description}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickAccess;
